module.exports = __webpack_public_path__ + "static/media/logo.8887ae4c.png";